export default "__VITE_ASSET__B$JHCX9Y__"